import React, { useState } from 'react';
import Pickup from './pickupForm.js';
import Header from '../../../header/header.js';
import Navvbar from '../../../header/Navvbar.js';

const NewCasePickup = ({ heading }) => {
  // Example static accounts data or you can pass accounts as props instead
  const accounts = [
    { id: '1', account_name: 'Account A' },
    { id: '2', account_name: 'Account B' },
    { id: '3', account_name: 'Account C' },
  ];

  const [selectedAccount, setSelectedAccount] = useState("");

  const handleAccountChange = (event) => {
    setSelectedAccount(event.target.value);
  };

  return (
    <>
      <Header />
      <Navvbar />
      <div style={{ width: "100%" }}>
        <br />
        <div style={{ width: '95%', margin: '0 auto', padding: "0px" }}>
          <h2 className="fancy-heading">New Case Pickup</h2>
          <h2 className="title">Account Details</h2>
          
          <div style={{ border: '1px solid #ccc', padding: '20px', borderTop: '3px solid #004aad', backgroundColor: "#f4f4f4", width: "100%" }}>
            <div className="row">
              <div className="col-3">
                <label htmlFor="account" className="form-label">Account</label>
                <select
                  id="account"
                  name="account"
                  className="form-select form-select-sm"
                  value={selectedAccount}
                  onChange={handleAccountChange}
                >
                  <option value="" disabled>Select Account</option>
                  {accounts.map(account => (
                    <option key={account.id} value={account.id}>
                      {account.account_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      {selectedAccount && <Pickup account={selectedAccount} />}

    
    </>
  );
};

export default NewCasePickup;
